<template>
  <!-- Кнопки входа через бота. MAX появляется, только если задан адрес его
       бота: без префикса ссылка никуда не ведёт. -->
  <div class="flex w-[368px] flex-col gap-3 max-md:w-full">
    <UINewButton
      class="flex items-center justify-center gap-1 !h-[50px] !w-full !max-w-full !rounded-[12px] !py-0 !text-base"
      :disabled="isLoading"
      @click="login('telegram')"
    >
      <span v-if="isLoading && pendingMessenger === 'telegram'" class="loader mr-2"></span>
      <span v-else class="mr-2 flex text-[24px] text-white">
        <i class="fi fi-brands-telegram"></i>
      </span>
      Telegram
    </UINewButton>

    <UINewButton
      v-if="hasMax"
      class="flex items-center justify-center gap-1 !h-[50px] !w-full !max-w-full !rounded-[12px] !py-0 !text-base"
      :disabled="isLoading"
      @click="login('max')"
    >
      <span v-if="isLoading && pendingMessenger === 'max'" class="loader mr-2"></span>
      <UINewIconsSocialIMax v-else class="mr-2 size-6 shrink-0" color="#fff" />
      MAX
    </UINewButton>
  </div>
</template>

<script setup lang="ts">
  import UINewButton from "~/components/UINew/Button.vue";
  import type { BindMessenger } from "~/services/AuthService";
  import { useUserStore } from "~/store/UserModule";

  const userModule = useUserStore();

  const isLoading = computed(() => userModule.isLoadingTelegramAuthorize);
  const hasMax = computed(() => !!useRuntimeConfig().public.RESOLVE_MAX_AUTHORIZE_PREFIX);

  // Крутилку показываем только на той кнопке, по которой нажали
  const pendingMessenger = ref<BindMessenger>("telegram");

  const login = (messenger: BindMessenger) => {
    pendingMessenger.value = messenger;
    userModule.startMessengerAuthorize(messenger);
  };
</script>

<style scoped>
  .loader {
    width: 24px;
    height: 24px;
    border: 4px dotted #fff;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    box-sizing: border-box;
    animation: rotation 2s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
